<script>
	import AOT from "/vite/Icon.svelte";
	const rest = $props();
	const vars = {"attributes":{"viewBox":"0 0 8 8","fill":"none"},"iconId":"svg-3","raw":"<path d=\"M2.93169 5.29168L1.77502 4.13501C1.64502 4.00501 1.43502 4.00501 1.30502 4.13501C1.17502 4.26501 1.17502 4.47501 1.30502 4.60501L2.69835 5.99834C2.82835 6.12834 3.03835 6.12834 3.16835 5.99834L6.69502 2.47167C6.82502 2.34167 6.82502 2.13167 6.69502 2.00167C6.56502 1.87167 6.35502 1.87167 6.22502 2.00167L2.93169 5.29168Z\" fill=\"currentColor\"></path>"};
</script>

<AOT {...rest} {vars} />